<template>

  <!-- Product Header component displays product information and controls -->
  <product-header
      :active-product="activeProduct"
      :product="product"
      :is-b2b-domain="isB2bDomain"
      :in18="in18"
      :captcha_site_key="captcha_site_key"
      @change-active-product="changeActiveProduct"
  />

  <!-- Product Related Manual component determined manually -->
  <products-related-manual
      :product="product"
      :in18="in18"
  />
  <!-- Product Variations component provides product variations -->
  <product-variations
      :product="product"
      :in18="in18"
      @change-active-product="changeActiveProduct"
  />
  <!-- Recommended Products component shows products recommended for purchase with this product -->
  <recommended-products
      :product="product"
      :in18="in18"
  />

  <!-- Related Products component displays products that were purchased together with this item -->
  <products-related-auto
      :product="product"
      :in18="in18"
  />
  
  <!-- Product Information component display detailed information about the product -->
  <product-information
      :product="product"
      :in18="in18"
  />

<product-reviews
    :product="product"
    :in18="in18"
  />
  
  <!-- Recently Bought Products component shows products recently purchased by users -->
  <recently-bought-products
      :in18="in18"
  />

</template>

<script>

import ProductHeader from "../components/product/ProductHeader.vue";
import ProductVariations from "../components/product/ProductVariations.vue";
import ProductInfoTabs from "../components/product/ProductInfoTabs.vue";
import ProductsRelatedAuto from "../components/product/ProductsRelatedAuto.vue";
import RecentlyBoughtProducts from "../components/product/RecentlyBoughtProducts.vue";
import RecommendedProducts from "../components/product/RecommendedProducts.vue";
import ProductRelatedManual from "../components/product/ProductRelatedManual.vue";
import AutoSlider from "../components/sliders/AutoSlider.vue";
import ProductInformation from "../components/product/ProductInformation.vue";
import ProductReviews from "../components/product/ProductReviews.vue";


export default {
  name: "Product",

  components: {
    'auto-slider': AutoSlider,
    'product-header': ProductHeader,
    'product-variations': ProductVariations,
    'product-info-tabs': ProductInfoTabs,
    'products-related-manual': ProductRelatedManual,
    'products-related-auto': ProductsRelatedAuto,
    'recently-bought-products': RecentlyBoughtProducts,
    'recommended-products': RecommendedProducts,
    'product-information': ProductInformation,
    'product-reviews': ProductReviews,

},

  props: {
    isB2bDomain:      Boolean,
    product:          Object,  // The product object to display
    in18:             Object,  // Internationalization object for language support
    user:             Object,
    captcha_site_key: {
      type: String  // CAPTCHA site key for anti-bot protection
    },
    locale: String,
  },

  data() {
    return {
      activeProduct: this.product,  // Currently active product
    }
  },
  methods: {
    // Method to change the active product
    changeActiveProduct(product) {
      this.activeProduct = product;
    }
  }
}
</script>